import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { ReactComponent as SvgDotPatternIcon } from "../../images/dot-pattern.svg";
import Feature1 from "../../images/assests/f1.png";
import Feature2 from "../../images/assests/f2.png";
import Feature3 from "../../images/assests/f3.png";
import Feature4 from "../../images/assests/f4.png";
import Feature5 from "../../images/assests/f5.png";
import Feature6 from "../../images/assests/f6.png";
import Feature7 from "../../images/assests/f7.png";
import Feature8 from "../../images/assests/f8.png";
import Feature9 from "../../images/assests/f9.png";
import Feature10 from "../../images/assests/f10.png";
import Feature11 from "../../images/assests/f11.png";
import Feature12 from "../../images/assests/f12.png";
import Feature13 from "../../images/assests/f13.png";
import Feature14 from "../../images/assests/f14.png";
import Feature15 from "../../images/assests/f15.png";
import { SectionHeading as HeadingTitle } from "../misc/Headings.js";

import Header from "../headers/light.js";

const Container = tw.div`relative mt-5`;

const SingleColumn = tw.div`max-w-screen-xl mx-auto py-24`;

const HeadingInfoContainer = tw.div`flex flex-col items-center`;
const HeadingDescription = tw.p`mt-4 font-medium text-gray-600 text-center max-w-xl`;

const Content = tw.div`mt-16`;

const Card = styled.div((props) => [
  tw`mt-24 md:flex justify-center items-center`,
  props.reversed ? tw`flex-row-reverse` : "flex-row",
]);
const Image = styled.div((props) => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded md:w-1/2 lg:w-5/12 xl:w-1/3 flex-shrink-0 h-80 md:h-144 bg-cover bg-no-repeat bg-center mx-4 sm:mx-8 md:mx-4 lg:mx-8 border-2`,
]);
const Details = tw.div`mt-4 md:mt-0 md:max-w-md mx-4 sm:mx-8 md:mx-4 lg:mx-8`;
const Subtitle = tw.div`font-bold tracking-wide text-secondary-100`;
const Title = tw.h4`text-3xl font-bold text-gray-900`;
const Description = tw.p`mt-2 text-sm leading-loose`;
const Link = tw.a`inline-block mt-4 text-sm text-primary-500 font-bold cursor-pointer transition duration-300 border-b-2 border-transparent hover:border-primary-500`;

const SvgDotPattern1 = tw(
  SvgDotPatternIcon
)`absolute top-0 left-0 transform -translate-x-20 rotate-90 translate-y-8 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern2 = tw(
  SvgDotPatternIcon
)`absolute top-0 right-0 transform translate-x-20 rotate-45 translate-y-24 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern3 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 left-0 transform -translate-x-20 rotate-45 -translate-y-8 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern4 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 right-0 transform translate-x-20 rotate-90 -translate-y-24 -z-10 opacity-25 text-primary-500 fill-current w-24`;

export default () => {
  const cards = [
    {
      imageSrc: Feature1,
      subtitle: "Paid",
      title: "Patient Dashboard",
      description:
        "Provides a comprehensive view of patient information, including demographics, medical history, test results, allergies, and current medications.",
      url: "https://timerse.com",
    },

    {
      imageSrc: Feature2,
      subtitle: "Free",
      title: "Appointment Management",
      description:
        "Allows scheduling and managing appointments with automated reminders and tracking of no-shows and cancellations.",
      url: "https://timerse.com",
    },

    {
      imageSrc: Feature3,
      subtitle: "Exclusive",
      title: "Billing and Claims",
      description:
        "Automates the billing process, including electronic claims submission, tracking payment statuses, and managing insurance information.",
      url: "https://timerse.com",
    },

    {
      imageSrc: Feature4,
      subtitle: "Exclusive",
      title: "Clinical Documentation",
      description:
        "Offers templates and tools to create structured and customizable clinical notes, including SOAP notes, progress reports, and discharge summaries.",
      url: "https://timerse.com",
    },

    {
      imageSrc: Feature5,
      subtitle: "Exclusive",
      title: "E-Prescribing:",
      description:
        "Enables physicians to electronically prescribe medications, check drug interactions, and access the patient's medication history to ensure safety and accuracy.",
      url: "https://timerse.com",
    },

    {
      imageSrc: Feature6,
      subtitle: "Exclusive",
      title: "Orders and Results Management",
      description:
        "Facilitates the ordering of lab tests, imaging, and other procedures, with the ability to electronically receive and store results for easy access.",
      url: "https://timerse.com",
    },

    {
      imageSrc: Feature7,
      subtitle: "Exclusive",
      title: "Health Information Exchange",
      description:
        "Supports interoperability by securely exchanging patient data with other healthcare systems and providers to facilitate coordinated care.",
      url: "https://timerse.com",
    },

    {
      imageSrc: Feature8,
      subtitle: "Exclusive",
      title: "Decision Support",
      description:
        "Provides alerts, reminders, and clinical guidelines based on evidence-based medicine and best practices to aid in making informed decisions.",
      url: "https://timerse.com",
    },

    {
      imageSrc: Feature9,
      subtitle: "Exclusive",
      title: "ZATCA Compliance",
      description: "Fully compliance with ZATCA for E Invoice Generations.",
      url: "https://timerse.com",
    },

    {
      imageSrc: Feature10,
      subtitle: "Exclusive",
      title: "Reporting and Analytics",
      description:
        "Generates reports and analytics on various aspects of patient care, population health, and practice performance to drive quality improvement and efficiency.",
      url: "https://timerse.com",
    },

    {
      imageSrc: Feature11,
      subtitle: "Exclusive",
      title: "Compliance and Security",
      description:
        "Ensures compliance with privacy laws (e.g., HIPAA) and provides robust data security measures to protect patient information.",
      url: "https://timerse.com",
    },

    {
      imageSrc: Feature12,
      subtitle: "Exclusive",
      title: "Mobile Accessibility",
      description:
        "Offers mobile apps or browser access to allow healthcare professionals to access patient records, schedule appointments, and perform essential tasks on the go.",
      url: "https://timerse.com",
    },

    {
      imageSrc: Feature13,
      subtitle: "Exclusive",
      title: "Telehealth Integration",
      description:
        "Enables telehealth capabilities, including video consultations, remote monitoring, and electronic communication with patients.",
      url: "https://timerse.com",
    },

    {
      imageSrc: Feature14,
      subtitle: "Exclusive",
      title: "Insurnace Integrtion",
      description:
        "Integrated with Insurnace companies for Eligibility, Apporoval and Clams submission, Specifically GCC and Sudui arabia, ie NAPHIES, WASEEL, DHS.",
      url: "https://timerse.com",
    },

    {
      imageSrc: Feature15,
      subtitle: "Exclusive",
      title: "Revenue Cycle Management",
      description:
        "Dedicated Modle to manage ene revenue, decrease the rejection percentage of insurance claims.",
      url: "https://timerse.com",
    },

    {
      imageSrc: Feature1,
      subtitle: "Exclusive",
      title: "Multibrach and Unified Patent File Number",
      description:
        "Tabebek Support Multibranch and unified file numeber to access the patinet date from one branch to other.",
      url: "https://timerse.com",
    },

    {
      imageSrc: Feature1,
      subtitle: "Exclusive",
      title: "Staff Schedule Management",
      description:
        "Staff Schedulign to book appoitment  as per availibility of doctors.",
      url: "https://timerse.com",
    },

    {
      imageSrc: Feature1,
      subtitle: "Exclusive",
      title: "Reminders Managmenet",
      description:
        "Send Reminders on appointement scheduling to decrease the no show from patients.",
      url: "https://timerse.com",
    },

    {
      imageSrc: Feature1,
      subtitle: "Exclusive",
      title: "Inventory Management",
      description:
        "Management invnetory by Clinic and attahce with services to have proper costing of the inventory in clinic and service provided by Doctors.",
      url: "https://timerse.com",
    },

    {
      imageSrc: Feature1,
      subtitle: "Exclusive",
      title: "Integrated ERP",
      description:
        "Full ERP features to manage, receceivbales, payables, emplopyees, fixed assets, financial reporting.",
      url: "https://timerse.com",
    },
  ];

  return (
    <>
      <Header roundedHeaderButton={false} />
      <Container>
        <SingleColumn>
          <HeadingInfoContainer>
            <HeadingTitle> Features</HeadingTitle>
            <HeadingDescription>
              Tabebek Electronic Health Record (EHR) software offers a wide
              range of features to streamline and manage healthcare records
              effectively. Here is a list of some of its key features:
            </HeadingDescription>
          </HeadingInfoContainer>

          <Content>
            {cards.map((card, i) => (
              <Card key={i} reversed={i % 2 === 1}>
                <Image imageSrc={card.imageSrc} />
                <Details>
                  <Subtitle>..................</Subtitle>
                  <Title>{card.title}</Title>
                  <Description>{card.description}</Description>
                  <Link
                  // href={card.url}
                  >
                    See Event Details
                  </Link>
                </Details>
              </Card>
            ))}
          </Content>
        </SingleColumn>
        {/* <SvgDotPattern1 />
        <SvgDotPattern2 />
        <SvgDotPattern3 />
        <SvgDotPattern4 /> */}
      </Container>
    </>
  );
};
